<template>
    <div class="confirm">
        <div class="box uk-position-center">
            <p class="uk-margin-small-bottom">{{ text }}</p>
            <div>
                <button class="uk-button-default uk-buttom-small" @click="cancel()">Cancel</button>
                <button class="uk-button-primary uk-buttom-small" @click="confirm()">Yes</button>
            </div>
        </div>
    </div>
</template>

<script lang="js">
import Vue from "vue";

export default Vue.extend({
    name: "ConfirmBox",
    props: {
        text: {
            required: true,
            type: String,
        },
    },
    methods: {
        cancel() {
            this.$emit("confirmed", false);
        },
        confirm() {
            this.$emit("confirmed", true);
        },
    },
});
</script>
